// extracted by mini-css-extract-plugin
export default {"nav":"Nav_nav__TXC9q","child":"Nav_child__4p4ka","active":"Nav_active__y3hDN"};